import React from "react";
import history from "../utils/history";
import { Auth0Provider } from "@auth0/auth0-react";
import App from "./App";

export const DateFormetContext = React.createContext();

const AppWrapper = () => {
  const onRedirectCallback = (appState) => {
    history.push(
      appState && appState.returnTo
        ? appState.returnTo
        : window.location.pathname
    );
  };

  return (
    <>
      <Auth0Provider
        domain={process.env.REACT_APP_AUTH0_DOMAIN}
        clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
        redirectUri={process.env.REACT_APP_REDIRECT_URL}
        onRedirectCallback={onRedirectCallback}
        cacheLocation="localstorage"
        issuer={process.env.REACT_APP_ISSUER}
        audience={process.env.REACT_APP_AUDIANCE}
        scope={process.env.REACT_APP_SCOPE}
      >
        <App />
      </Auth0Provider>
    </>
  );
};
export default AppWrapper;
